import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useAuthStore = create()(persist((set, get) => ({
    user: null,
    accessToken: null,
    refreshToken: null,
    setSession: ({ user, accessToken, refreshToken }) => set({ user, accessToken, refreshToken }),
    logout: () => set({ user: null, accessToken: null, refreshToken: null }),
    hasPerm: (p) => !!get().user?.perms.includes(p),
}), { name: 'hbt-auth' }));
